import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';

import {CommonContent, CommonTitle, CommonSubTitle} from './LightHomePage.style';
import {
  DishesWrapper,
  Wrapper,
  Block,
  DishBlock,
  OrderNow,
  SliceUp,
  Title,
  Description,
  BlockBody
} from './Dishes.style';

export const Dishes = props => {
  const {block, OrderButtonText, navUrls} = props;
  const renderSubTitle = block.subtitle && <CommonSubTitle>{block.subtitle}</CommonSubTitle>;
  const renderPics = block.pictures && block.pictures.map((pic, i) => {
    if (!pic.url) {
      return;
    }
    return (
      <Block
        key={pic.title + i}
        url={pic.url}
      >
        <SliceUp>
          <Title>{pic.title}</Title>
          <Description>{pic.subtitle}</Description>
          <Link to={pic.mealUuid ? `${navUrls.menuUrl}?mealUuid=${pic.mealUuid}` : navUrls.menuUrl}>
            <OrderNow>
              <FormattedMessage id="button.orderNow" />
            </OrderNow>
          </Link>
        </SliceUp>
      </Block>
    );
  });
  return (
    <DishesWrapper
      name={block.navigationTitle}
      id={block.navigationTitle}
    >
      <CommonContent>
        <CommonTitle>{block.title}</CommonTitle>
        {renderSubTitle}
        <Wrapper>
          {renderPics}
          <DishBlock>
            <BlockBody>{block.body}</BlockBody>
            <Link to={navUrls.menuUrl}>
              <OrderNow>
                <FormattedMessage id={OrderButtonText} />
              </OrderNow>
            </Link>
          </DishBlock>
        </Wrapper>
      </CommonContent>
    </DishesWrapper>
  );
};

Dishes.propTypes = {
  block: PropTypes.object.isRequired,
  OrderButtonText: PropTypes.string,
  navUrls: PropTypes.object
};



// WEBPACK FOOTER //
// ./containers/LightHomePage/Dishes.js